<template>
  <div class="confirm-layout">
    <div class="alert alert-success">
      此藥物總存量: {{ selectedDrugTotalAmount }} 
    </div>
    <Action 
      v-if="currentProgress === 'action'"
      v-on:setActionData="getActionData" 
      :inputReadOnly="true"
      :defaultPackContent="0"
      :checkNum="currentEvent.number1"
      :defaultNum="currentEvent.number1"
      :deviceId="currentEvent.device.id">
      <h5>回收退藥盒藥物</h5>
    </Action>
    <Loader v-if="currentProgress === 'finish'" />
  </div>
</template>


<script>
import ConfirmBaseFlow from '../ComponentBase/ConfirmFlowBase';
import Action from '../flowComp/Action';
import Loader from '../common/Loader';

export default {
  name: 'ConfirmFlow',
  extends: ConfirmBaseFlow,
  props: [],
  data() {
    return {
      amount: 0,
      emitTimes: 0,
    };
  },
  components: {
    Action,
    Loader,
  },
  mounted() {
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
  },
  methods: {
    getActionData(data) {
      if (this.emitTimes === 0) {
        this.amount = data.num;
        this.emitData();
      }
      this.emitTimes += 1;
    },
    emitData() {
      this.nextProgress();
      const event = {
        id: this.currentEvent.id,
        checked: true,
      };
      // delete the drugStorage
      this.instance.delete(`/api/drug-storage/${this.currentEvent.drug_storage}/`, {
        data: {
          type: 'RECYCLE',
        },
      });
      this.$emit('confirmationFinish');
      // patch the event as checked.
      this.instance.patch(`/api/event/${event.id}/`, event);
      this.resetProgress();
      this.emitTimes = 0;
    },
  },
  computed: {
  },
};
</script>



// WEBPACK FOOTER //
// ConfirmFlow.vue?68535414